<template>
  <div class="listBox">
    <ul class="sBox">
      <li style="flex: 1">
        <el-input v-model="state.params.Params.Key" placeholder="关键词" clearable style="width: 180px" @clear="onSearch" />
        <el-select v-model="state.params.Params.Lx" placeholder="券类型" clearable style="width: 120px; margin-left: 10px" @change="onSearch">
          <el-option label="酒店" value="2" />
          <el-option label="门票" value="3" />
          <el-option label="联合套餐" value="4" />
        </el-select>
        <el-select v-model="state.params.Params.Status" placeholder="状态" clearable style="width: 120px; margin-left: 10px" @change="onSearch">
          <el-option label="启用" value="active" />
          <el-option label="停用" value="inactive" />
        </el-select>
        <el-dropdown split-button @click="onSearch" type="primary" style="margin-left: 10px">
          查询
          <template #dropdown>
            <el-dropdown-menu>
              <el-dropdown-item :icon="RefreshLeft" @click="onReset">重置</el-dropdown-item>
            </el-dropdown-menu>
          </template>
        </el-dropdown>
      </li>
      <li style="display: flex; align-items: center">
        <el-button type="success" icon="Plus" link @click="onAdd">新建券</el-button>
      </li>
    </ul>
    <ul class="tBox">
      <el-table :data="state.list" border v-loading="state.loading" size="small" stripe
        :default-sort="{ prop: 'Status', order: 'ascending' }"
        @sort-change="onSortChange">
      <el-table-column label="序号" type="index" width="55" align="center" />
      <el-table-column label="封面" width="80" align="center">
        <template #default="{ row }">
          <el-image v-if="row.Fm" :src="getImageUrl(row.Fm)" style="width: 50px; height: 50px; border-radius: 4px" fit="cover" :preview-src-list="[getImageUrl(row.Fm)]" />
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column label="券名称" prop="Mc" min-width="150" />
      <el-table-column label="券类型" width="100" align="center">
        <template #default="{ row }">
          <el-tag size="small">{{ lxMap[row.Lx] || row.Lx }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="面额类型" width="100" align="center">
        <template #default="{ row }">
          <el-tag size="small" :type="row.Mzlx === 'cash' ? 'danger' : 'warning'">{{ row.Mzlx === 'cash' ? '满减' : '折扣' }}</el-tag>
        </template>
      </el-table-column>
            <el-table-column label="状态" width="80" align="center" sortable="custom" prop="Status">
        <template #default="{ row }">
          <el-tag size="small" :type="row.Status === 'active' ? 'success' : 'danger'">{{ row.Status === 'active' ? '启用' : '停用' }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="面额/折扣" width="110" align="center">
        <template #default="{ row }">
          <span v-if="row.Mzlx === 'cash'">¥{{ row.Mje }}</span>
          <span v-else>{{ row.Mje }}折</span>
        </template>
      </el-table-column>
      <el-table-column label="门槛" width="120" align="center">
        <template #default="{ row }">{{ row.Mj ? '满¥' + row.Mj : '无门槛' }}</template>
      </el-table-column>
      <el-table-column label="有效期" width="150" align="center">
        <template #default="{ row }">
          <span v-if="row.YxqLx === 'fixed'">{{ row.YxqStart?.slice(0,10) }} ~ {{ row.YxqEnd?.slice(0,10) }}</span>
          <span v-else>领取后{{ row.YxqDays }}天</span>
        </template>
      </el-table-column>
      <el-table-column label="余量/库存" width="100" align="center">
        <template #default="{ row }">{{ row.Sykc }}/{{ row.Zzl }}</template>
      </el-table-column>
      <el-table-column label="每人限领" width="90" align="center" prop="Mylxcs" />
      <el-table-column label="领取对象" width="90" align="center">
        <template #default="{ row }">{{ row.Dxlx === 'yk' ? '游客' : '客户' }}</template>
      </el-table-column>
      <el-table-column label="发放方式" width="100" align="center">
        <template #default="{ row }">
          <el-tag size="small" :type="row.FfFs === 'auto' ? 'success' : 'info'">{{ row.FfFs === 'auto' ? '自动发放' : '通知领取' }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="280" align="center" fixed="right">
        <template #default="{ row }">
          <el-button size="small" type="primary" link @click="onEdit(row)">编辑</el-button>
          <el-button size="small" type="warning" link @click="onIssue(row)">发放</el-button>
          <el-button size="small" link @click="onViewLogs(row)">日志</el-button>
          <el-button size="small" link @click="onViewReceive(row)">领取记录</el-button>
          <el-button size="small" :type="row.Status === 'active' ? 'danger' : 'success'" link @click="onToggle(row)">
            {{ row.Status === 'active' ? '停用' : '启用' }}
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    </ul>

    <c_page :total="state.total" :pageIndex="state.params.PageIndex" @onLoad="onPageChange" />

    <!-- 新建/编辑弹窗 -->
    <el-dialog v-model="state.formVisible" :title="state.isEdit ? '编辑优惠券' : '新建优惠券'" width="700px" destroy-on-close>
      <el-form :model="state.form" label-width="110px" size="small">
        <el-form-item label="券名称" required>
          <el-input v-model="state.form.Mc" placeholder="请输入券名称" />
        </el-form-item>
        <el-form-item label="封面图片">
          <el-upload
            action="#"
            :auto-upload="false"
            :show-file-list="false"
            :on-change="onUploadChange"
            accept="image/*"
            class="coupon-fm-upload"
          >
            <el-image v-if="state.form.Fm" :src="getImageUrl(state.form.Fm)" style="width: 100px; height: 100px; border-radius: 8px" fit="cover" />
            <el-button v-else type="primary" plain>上传封面</el-button>
          </el-upload>
          <div v-if="state.form.Fm" style="margin-top: 8px">
            <el-button type="danger" link size="small" @click="onRemoveFm">删除</el-button>
          </div>
          <div style="color: #999; font-size: 12px; margin-top: 4px">建议尺寸 1:1，可为空</div>
        </el-form-item>
        <el-form-item label="券类型" required>
          <el-select v-model="state.form.Lx" style="width: 100%">
            <el-option label="酒店" value="2" />
            <el-option label="门票" value="3" />
            <el-option label="联合套餐" value="4" />
          </el-select>
        </el-form-item>
        <el-form-item label="面额类型" required>
          <el-radio-group v-model="state.form.Mzlx">
            <el-radio label="cash">满减券</el-radio>
            <el-radio label="discount">折扣券</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item :label="state.form.Mzlx === 'cash' ? '面额(元)' : '折扣(折)'" required>
          <el-input-number v-model="state.form.Mje" :min="0.01" :precision="2" style="width: 200px" />
        </el-form-item>
        <el-form-item label="使用门槛">
          <el-radio-group v-model="hasMj">
            <el-radio :label="false">无门槛</el-radio>
            <el-radio :label="true">满减门槛</el-radio>
          </el-radio-group>
          <el-input-number v-if="hasMj" v-model="state.form.Mj" :min="0.01" :precision="2" style="width: 200px; margin-left: 10px" placeholder="满多少元可用" />
        </el-form-item>
        <el-form-item label="适用范围" required>
          <el-radio-group v-model="state.form.SyfwLx">
            <el-radio label="all">全部商品</el-radio>
            <el-radio label="designated">指定商品</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item v-if="state.form.SyfwLx === 'designated'" label="适用商品">
          <el-select v-model="state.form.SyfwSpIds" multiple filterable placeholder="选择商品" style="width: 100%">
            <el-option v-for="sp in state.spList" :key="sp.Id" :label="sp.Mc" :value="sp.Id.toString()" />
          </el-select>
        </el-form-item>
        <el-form-item label="有效期类型" required>
          <el-radio-group v-model="state.form.YxqLx">
            <el-radio label="fixed">固定日期</el-radio>
            <el-radio label="afterReceive">领取后N天有效</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item v-if="state.form.YxqLx === 'fixed'" label="有效期" required>
          <el-date-picker v-model="state.form.YxqRange" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="YYYY-MM-DD" />
        </el-form-item>
        <el-form-item v-else label="有效天数" required>
          <el-input-number v-model="state.form.YxqDays" :min="1" :max="365" style="width: 200px" />
          <span style="margin-left: 8px; color: #999">天</span>
        </el-form-item>
        <el-form-item label="发放总量" required>
          <el-input-number v-model="state.form.Zzl" :min="1" :max="999999" style="width: 200px" />
        </el-form-item>
        <el-form-item label="每人限领次数" required>
          <el-input-number v-model="state.form.Mylxcs" :min="1" :max="99" style="width: 200px" />
        </el-form-item>
        <el-form-item label="领取对象" required>
          <el-radio-group v-model="state.form.Dxlx">
            <el-radio label="yk">游客</el-radio>
            <el-radio label="kh">客户</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="发放方式" required>
          <el-radio-group v-model="state.form.FfFs">
            <el-radio label="auto">直接发放到用户账户</el-radio>
            <el-radio label="notice">通知用户领取</el-radio>
          </el-radio-group>
          <div style="margin-top:4px;color:#999;font-size:12px">
            <span v-if="state.form.FfFs === 'auto'">创建后自动发放给符合条件的用户，无需用户操作</span>
            <span v-else>首页弹窗+商品详情页展示，用户手动点击领取</span>
          </div>
        </el-form-item>
        <el-form-item label="领取说明">
          <el-input v-model="state.form.Lqsm" type="textarea" :rows="3" maxlength="500" show-word-limit placeholder="弹窗展示给客户看的描述文案，例如：限时特惠，满100减20" />
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button @click="state.formVisible = false">取消</el-button>
        <el-button type="primary" @click="onSave" :loading="state.saving">保存</el-button>
      </template>
    </el-dialog>

    <!-- 发放弹窗 -->
    <el-dialog v-model="state.issueVisible" title="发放优惠券" width="600px" destroy-on-close>
      <el-form size="small" label-width="100px">
        <el-form-item label="优惠券">{{ state.issueYhq?.Mc }}</el-form-item>
        <el-form-item label="发放对象">
          <el-select v-model="state.issueDxlx" style="width: 200px" :disabled="state.issueSelectAll">
            <el-option label="游客" value="yk" />
            <el-option label="客户" value="kh" />
          </el-select>
          <el-checkbox v-model="state.issueSelectAll" style="margin-left: 14px" @change="onSelectAllChange">全部对象</el-checkbox>
        </el-form-item>
        <el-form-item label="选择对象">
          <el-select
            v-model="state.issueIds"
            multiple
            filterable
            placeholder="输入关键字筛选已加载项，下拉滚动加载更多"
            style="width: 100%"
            :loading="state.issueTargetLoading"
            popper-class="yhq-issue-popper"
            :disabled="state.issueSelectAll"
            @visible-change="onTargetVisibleChange"
          >
            <el-option v-for="t in state.issueTargets" :key="t.Id" :label="t.Label" :value="t.Id" />
          </el-select>
          <div v-if="state.issueSelectAll" style="color:#67c23a;font-size:12px;margin-top:4px">
            将自动向全部符合条件的{{ state.issueDxlx === 'yk' ? '游客' : '客户' }}发放
          </div>
          <div v-else style="color:#909399;font-size:12px;margin-top:4px">
            已加载 {{ state.issueTargets.length }} / {{ state.issueTargetTotal }} 条，向下滚动加载更多
          </div>
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button @click="state.issueVisible = false">取消</el-button>
        <el-button type="primary" @click="onDoIssue" :loading="state.issuing">确认发放</el-button>
      </template>
    </el-dialog>

    <!-- 领取记录弹窗 -->
    <el-dialog v-model="state.receiveVisible" title="领取记录" width="900px" destroy-on-close>
      <el-table :data="state.receiveList" border size="small" max-height="400">
        <el-table-column label="券码" prop="Qm" width="180" />
        <el-table-column label="领取人" prop="LqrXm" width="100" />
        <el-table-column label="状态" width="80" align="center">
          <template #default="{ row }">
            <el-tag size="small" :type="statusType(row.Status)">{{ statusMap[row.Status] }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="发放类型" width="90" align="center">
          <template #default="{ row }">{{ row.FfLx === 'active' ? '主动发放' : '被动领取' }}</template>
        </el-table-column>
        <el-table-column label="领取时间" prop="LqSj" width="160" />
        <el-table-column label="有效期" width="200">
          <template #default="{ row }">{{ row.YxqStart?.slice(0,10) }} ~ {{ row.YxqEnd?.slice(0,10) }}</template>
        </el-table-column>
        <el-table-column label="使用时间" prop="SySj" width="160" />
        <el-table-column label="优惠金额" prop="YhJe" width="100" />
        <el-table-column label="操作人" prop="CzrXm" width="100" />
      </el-table>
      <c_page :total="state.receiveTotal" small :pageIndex="state.receivePage" @onLoad="onReceivePageChange" />
    </el-dialog>

    <!-- 日志弹窗 -->
    <el-dialog v-model="state.logVisible" title="操作日志" width="800px" destroy-on-close>
      <el-table :data="state.logList" border size="small" max-height="400">
        <el-table-column label="操作类型" width="90" align="center">
          <template #default="{ row }">{{ czlxMap[row.CzLx] || row.CzLx }}</template>
        </el-table-column>
        <el-table-column label="操作内容" prop="CzNr" min-width="250" />
        <el-table-column label="操作人" prop="CzrXm" width="100" />
        <el-table-column label="操作时间" prop="CzSj" width="160" />
      </el-table>
      <c_page :total="state.logTotal" small :pageIndex="state.logPage" @onLoad="onLogPageChange" />
    </el-dialog>
  </div>
</template>

<script>
import { reactive, watch, onMounted, computed, nextTick } from "vue";
import {
  youhuiquan_list, youhuiquan_detail, youhuiquan_add, youhuiquan_edit, youhuiquan_toggle, youhuiquan_issue, youhuiquan_receiveList, youhuiquan_logs, shangpin_list,
  youke_list, kehu_list,
  home_uploadconfig, home_uploadimages
} from "@/http/api";
import $http from "@/http/index";

export default {
  setup() {
    const state = reactive({
      loading: false,
      saving: false,
      issuing: false,
      list: [],
      total: 0,
      params: { PageSize: 20, PageIndex: 1, Params: {}, Order: "Status", Asc: true },
      spList: [],

      // 表单
      formVisible: false,
      isEdit: false,
      editId: null,
      form: {},

      // 发放
      issueVisible: false,
      issueYhq: null,
      issueDxlx: "yk",
      issueIds: [],
      issueTargets: [],
      issueTargetLoading: false,
      issueSelectAll: false,
      issueTargetPage: 1,
      issueTargetLimit: 20,
      issueTargetTotal: 0,
      issueTargetHasMore: true,

      // 领取记录
      receiveVisible: false,
      receiveList: [],
      receiveTotal: 0,
      receivePage: 1,
      receiveLimit: 20,
      receiveYhqId: null,

      // 日志
      logVisible: false,
      logList: [],
      logTotal: 0,
      logPage: 1,
      logLimit: 20,
      logYhqId: null,

      // 图片上传配置
      imageBaseUrl: "",
    });

    const hasMj = computed({
      get: () => state.form.Mj != null,
      set: (val) => { if (!val) state.form.Mj = null; else state.form.Mj = state.form.Mj || 0; }
    });

    // 上传相关
    const loadUploadConfig = () => {
      home_uploadconfig().then((res) => {
        if (res.status === 200) {
          const config = res.data;
          if (config.useOss && config.ossBaseUrl) {
            state.imageBaseUrl = config.ossBaseUrl;
          } else {
            state.imageBaseUrl = $http.defaults.baseURL;
          }
        }
      }).catch(() => {
        state.imageBaseUrl = $http.defaults.baseURL;
      });
    };

    const getImageUrl = (url) => {
      if (!url) return "";
      if (url.startsWith("http://") || url.startsWith("https://")) return url;
      if (state.imageBaseUrl) return state.imageBaseUrl + url;
      return $http.defaults.baseURL + url;
    };

    const onUploadChange = (file) => {
      const formData = new FormData();
      formData.append("files", file.raw);
      home_uploadimages(formData).then((res) => {
        if (res.status === 200 && res.data && res.data.length > 0) {
          state.form.Fm = res.data[0];
        }
      });
    };

    const onRemoveFm = () => {
      state.form.Fm = "";
    };

    const lxMap = { "2": "酒店", "3": "门票", "4": "联合套餐" };
    const statusMap = { UNUSED: "未使用", USED: "已使用", EXPIRED: "已过期", PENDING: "锁定中" };
    const czlxMap = { issue: "发放", receive: "领取", verify: "核销", refund: "退款", expire: "过期", compensate: "补偿" };

    const statusType = (s) => ({ UNUSED: "success", USED: "primary", EXPIRED: "info", PENDING: "warning" }[s]);

    onMounted(() => { onSearch(); loadSpList(); loadUploadConfig(); });

    const loadSpList = () => {
      shangpin_list({ PageSize: 999, PageIndex: 1, Params: {} }).then(res => {
        if (res.status === 200) state.spList = res.data.list || [];
      });
    };

    const onSearch = () => {
      state.loading = true;
      youhuiquan_list(state.params).then(res => {
        state.loading = false;
        if (res.status === 200) { state.list = res.data.list || []; state.total = res.data.count || 0; }
      }).catch(() => { state.loading = false; });
    };

    const onReset = () => {
      state.params.PageIndex = 1;
      state.params.PageSize = 20;
      state.params.Params = {};
      state.params.Order = "Status";
      state.params.Asc = true;
      onSearch();
    };

    const onPageChange = (pageIndex) => {
      state.params.PageIndex = pageIndex;
      onSearch();
    };

    const onSortChange = ({ prop, order }) => {
      if (prop) {
        state.params.Order = prop;
        state.params.Asc = order === 'ascending';
      } else {
        state.params.Order = "Status";
        state.params.Asc = true;
      }
      state.params.PageIndex = 1;
      onSearch();
    };

    const onAdd = () => {
      state.isEdit = false; state.editId = null;
      state.form = { Mc: "", Lx: "3", Mzlx: "cash", Mje: 10, Mj: null, SyfwLx: "all", SyfwSpIds: [], YxqLx: "afterReceive", YxqDays: 30, YxqRange: null, Zzl: 100, Mylxcs: 1, Dxlx: "yk", FfFs: "notice", Lqsm: "", Fm: "" };
      state.formVisible = true;
    };

    const onEdit = (row) => {
      youhuiquan_detail(row.Id).then(res => {
        if (res.status === 200) {
          const d = res.data;
          state.isEdit = true; state.editId = d.Id;
          const spIds = d.SyfwSpIds
            ? (Array.isArray(d.SyfwSpIds)
                ? d.SyfwSpIds.map(id => id.toString())
                : d.SyfwSpIds.toString().split(',').filter(Boolean))
            : [];
          state.form = {
            Mc: d.Mc, Lx: d.Lx, Mzlx: d.Mzlx, Mje: d.Mje, Mj: d.Mj,
            SyfwLx: d.SyfwLx, SyfwSpIds: spIds,
            YxqLx: d.YxqLx, YxqDays: d.YxqDays, Zzl: d.Zzl, Mylxcs: d.Mylxcs, Dxlx: d.Dxlx, FfFs: d.FfFs || 'notice',
            Lqsm: d.Lqsm || '',
            Fm: d.Fm || '',
            YxqRange: d.YxqStart && d.YxqEnd ? [d.YxqStart.slice(0,10), d.YxqEnd.slice(0,10)] : null
          };
          state.formVisible = true;
        }
      });
    };

    const onSave = () => {
      const f = state.form;
      if (!f.Mc || !f.Lx || !f.Mzlx) return;
      if (f.YxqLx === "fixed" && (!f.YxqRange || f.YxqRange.length < 2)) return;
      if (f.YxqLx === "afterReceive" && !f.YxqDays) return;
      if (!f.Zzl) return;
      if (!f.Mylxcs) return;

      const body = { ...f };
      if (body.YxqLx === "fixed" && body.YxqRange) {
        body.YxqStart = body.YxqRange[0] + " 00:00:00";
        body.YxqEnd = body.YxqRange[1] + " 23:59:59";
      }
      if (body.SyfwSpIds && body.SyfwSpIds.length > 0) {
        body.SyfwSpIds = body.SyfwSpIds.join(",");
      } else {
        body.SyfwSpIds = "";
      }
      delete body.YxqRange;
      if (body.Mj == null || body.Mj === "") body.Mj = null;

      state.saving = true;
      const api = state.isEdit ? youhuiquan_edit(state.editId, body) : youhuiquan_add(body);
      api.then(res => {
        state.saving = false;
        if (res.status === 200) { state.formVisible = false; onSearch(); }
      }).catch(() => { state.saving = false; });
    };

    const onToggle = (row) => {
      youhuiquan_toggle(row.Id).then(res => {
        if (res.status === 200) onSearch();
      });
    };

    // 发放
    const onIssue = (row) => {
      state.issueYhq = row;
      state.issueDxlx = row.Dxlx || "yk";
      state.issueIds = [];
      state.issueTargets = [];
      state.issueTargetTotal = 0;
      state.issueTargetHasMore = true;
      state.issueTargetPage = 1;
      state.issueSelectAll = false;
      state.issueVisible = true;
      loadTargets(true);
    };

    // 瀑布分页加载发放对象
    const loadTargets = (reset = true) => {
      if (state.issueSelectAll) return;
      if (reset) {
        state.issueTargetPage = 1;
        state.issueTargets = [];
        state.issueTargetHasMore = true;
      }
      state.issueTargetLoading = true;
      const params = {
        PageIndex: state.issueTargetPage,
        PageSize: state.issueTargetLimit,
        Order: "Id",
        Asc: false,
      };
      const req = state.issueDxlx === "yk"
        ? youke_list({ ...params, Params: { UserStatus: 1, TableName: "YouKe_List" } })
        : kehu_list({ ...params, Params: { TableName: "KeHu" } });
      req.then(res => {
        const list = res.data.list || [];
        const mapped = state.issueDxlx === "yk"
          ? list.map(y => ({ Id: y.Id, Label: `${y.Xm || y.NickName || ""}${y.Sjhm ? " - " + y.Sjhm : ""}` }))
          : list.map(k => ({ Id: k.Id, Label: k.Mc }));
        state.issueTargets = reset ? mapped : [...state.issueTargets, ...mapped];
        state.issueTargetTotal = res.data.count || 0;
        state.issueTargetHasMore = state.issueTargets.length < state.issueTargetTotal;
      }).finally(() => { state.issueTargetLoading = false; });
    };

    const loadMoreTargets = () => {
      if (state.issueTargetLoading || !state.issueTargetHasMore || state.issueSelectAll) return;
      state.issueTargetPage += 1;
      loadTargets(false);
    };

    // 全选切换：勾选后清空已选、不再加载下拉；取消勾选后重新加载
    const onSelectAllChange = (val) => {
      state.issueIds = [];
      state.issueTargets = [];
      state.issueTargetTotal = 0;
      state.issueTargetHasMore = false;
      if (!val) loadTargets(true);
    };

    // 下拉展开时为滚动容器绑定滚动加载（popper 已 teleport 到 body）
    let targetScrollEl = null;
    const onTargetScroll = () => {
      const el = targetScrollEl;
      if (!el) return;
      if (el.scrollHeight - el.scrollTop <= el.clientHeight + 30) loadMoreTargets();
    };
    const onTargetVisibleChange = (visible) => {
      if (state.issueSelectAll) return;
      if (visible) {
        nextTick(() => {
          const popper = document.querySelector(".yhq-issue-popper .el-select-dropdown__wrap");
          if (popper && popper !== targetScrollEl) {
            if (targetScrollEl) targetScrollEl.removeEventListener("scroll", onTargetScroll);
            targetScrollEl = popper;
            targetScrollEl.addEventListener("scroll", onTargetScroll);
          }
        });
      }
    };

    watch(() => state.issueDxlx, () => { state.issueIds = []; loadTargets(true); });

    const onDoIssue = () => {
      if (state.issueSelectAll) {
        state.issuing = true;
        youhuiquan_issue({ YhqId: state.issueYhq.Id, Ids: [], Dxlx: state.issueDxlx, IssueAll: true }).then(res => {
          state.issuing = false;
          if (res.status === 200) { state.issueVisible = false; onSearch(); }
        }).catch(() => { state.issuing = false; });
      } else {
        if (!state.issueIds.length) return;
        state.issuing = true;
        youhuiquan_issue({ YhqId: state.issueYhq.Id, Ids: state.issueIds, Dxlx: state.issueDxlx, IssueAll: false }).then(res => {
          state.issuing = false;
          if (res.status === 200) { state.issueVisible = false; onSearch(); }
        }).catch(() => { state.issuing = false; });
      }
    };

    // 领取记录
    const onViewReceive = (row) => {
      state.receiveYhqId = row.Id; state.receivePage = 1; state.receiveVisible = true; onLoadReceive();
    };
    const onLoadReceive = () => {
      youhuiquan_receiveList(state.receiveYhqId, state.receivePage, state.receiveLimit).then(res => {
        if (res.status === 200) { state.receiveList = res.data.list || []; state.receiveTotal = res.data.count || 0; }
      });
    };
    const onReceivePageChange = (pageIndex) => {
      state.receivePage = pageIndex;
      onLoadReceive();
    };

    // 日志
    const onViewLogs = (row) => {
      state.logYhqId = row.Id; state.logPage = 1; state.logVisible = true; onLoadLogs();
    };
    const onLoadLogs = () => {
      youhuiquan_logs(state.logYhqId, state.logPage, state.logLimit).then(res => {
        if (res.status === 200) { state.logList = res.data.list || []; state.logTotal = res.data.count || 0; }
      });
    };
    const onLogPageChange = (pageIndex) => {
      state.logPage = pageIndex;
      onLoadLogs();
    };

    return { state, hasMj, lxMap, statusMap, czlxMap, statusType, getImageUrl, onUploadChange, onRemoveFm,
      onSearch, onReset, onPageChange, onSortChange, onAdd, onEdit, onSave, onToggle,
      onIssue, onDoIssue, onSelectAllChange, onTargetVisibleChange,
      onViewReceive, onLoadReceive, onReceivePageChange, onViewLogs, onLoadLogs, onLogPageChange };
  }
};
</script>
